import channelAvatar from "assets/channel.png"

import { IDiscussionInfo } from "./queries"
import styles from "./styles.module.scss"
import { Avatar, Tag } from "antd"
import { useMemo } from "react"
import moment from "moment"
import i18next from "i18next"
import { useMemberId } from ".."
import { useMember } from "../queries"

type Props = {
  discussionHeader: IDiscussionInfo
}

const DiscussionHeader: React.FC<Props> = ({
  discussionHeader: { created_at },
}) => {
  const id = useMemberId()
  const member = useMember(id)

  const lastMessageTime = useMemo(() => {
    moment.locale(i18next.language)
    return moment(created_at).fromNow()
  }, [i18next.language, created_at])

  return (
    <>
      <div className={styles.head}>
        <Avatar className={styles.avatar} src={channelAvatar} size="large" />
        <div>
          <h3 className="subheader-heavy">{member.data?.name} / La parolière  team </h3>
          <div className={styles.labels}>
            <Tag className="caption-heavy" color="green">
              Support
            </Tag>
            <Tag className="caption-heavy" color="blue">
              Tesymo
            </Tag>
          </div>
        </div>
        <div className={styles.infos}>
          <span className="caption">{lastMessageTime}</span>
        </div>
      </div>
    </>
  )
}

export default DiscussionHeader
